import {FC, HTMLAttributes, useCallback} from "react";

export enum TabState {
  ATTRIB_LIST = "ATTRIB_LIST",
  ATTRIB_MAP = "ATTRIB_MAP",
  ATTRIB_DISPLAY = "ATTRIB_DISPLAY",
}

export type TabStateButtonProps = HTMLAttributes<HTMLButtonElement> & {
  tabState: TabState;
  currentTabState: TabState;
  setCurrentTabState: (tabState: TabState) => void;
}

export const TabStateButton: FC<TabStateButtonProps> = ({
                                                          tabState,
                                                          currentTabState,
                                                          setCurrentTabState,
                                                          ...otherProps
                                                        }) => {
  const onButtonClick = useCallback(() => {
    setCurrentTabState(tabState);
  }, [tabState, setCurrentTabState]);

  return (
    <button
      {...otherProps}
      onClick={onButtonClick}
      disabled={tabState === currentTabState}
    />
  );
};
